<template>
  <path pid="0" d="M7 19h3a1 1 0 000-2H7a4 4 0 010-8h3a1 1 0 000-2H7a6 6 0 000 12z"/><path pid="1" d="M8 13a1 1 0 001 1h8a1 1 0 000-2H9a1 1 0 00-1 1z"/><path pid="2" d="M19 7h-3a1 1 0 000 2h3a4 4 0 010 8h-3a1 1 0 000 2h3a6 6 0 000-12z"/>
</template>
